import {Injectable} from '@angular/core';

@Injectable()
export class ExperimentsInfoEffects {
  constructor() { /* empty */ }
}
